module.exports = __webpack_public_path__ + "static/media/servicio1.8041ad1a.jpg";